// extracted by mini-css-extract-plugin
export default {"title":"Team_title__XN5NM","membersContainer":"Team_membersContainer__Ng7-Z","memberItem":"Team_memberItem__GFqOp"};